"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _makeObjectRecord = _interopRequireDefault(require("../record/makeObjectRecord"));

var _ObjectTypes = require("../constants/ObjectTypes");

var _ObjectIds = _interopRequireDefault(require("../constants/ObjectIds"));

var _default = (0, _makeObjectRecord.default)({
  idKey: _ObjectIds.default[_ObjectTypes.COMPANY],
  objectType: _ObjectTypes.COMPANY,
  recordName: 'CompanyRecord',
  defaults: {
    companyId: null,
    isDeleted: false,
    portalId: null,
    properties: (0, _immutable.Map)(),
    additionalDomains: (0, _immutable.List)()
  }
}, {
  primary: ['name'],
  secondary: ['domain']
});

exports.default = _default;
module.exports = exports.default;